import React, { Component } from 'react';
import {Alert, Button, Col, Form ,Input, message, Row , Checkbox } from "antd"
import axios from 'axios'
import { connect } from 'react-redux';
import Password from 'antd/lib/input/Password';

class EditEmployee extends Component{


    state = {
        confirmDirty : null,
        data : {},
        resetPassword : false
    }

    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
      };



    componentDidMount(){
      this.updateEmployee(this.props.match.params.id,{})
    }


    updateEmployee = (id,data)=>{
        this.setState({
            loading : true
        },()=> {
            axios.patch(`${this.props.server}/user/employee/${id}/`,data)
            .then(
                response => {
                    this.setState({
                        loading:false,
                        data : response.data
                    })
                    message.success("Update successful")
                }
            )
            .catch(er => {
                console.error(er)
                message.error("Update Employee Failed")
                this.setState({
                    loading:false
                })
            })
        }
        )
       
    } 


    handleSubmit = (e)=>{
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
              console.log('Received values of form: ', values);
              this.updateEmployee(this.props.match.params.id , {
                  first_name : values.firstName,
                  last_name : values.lastName,
                  contact_no : values.contactNo,
                  nic : values.nic,
                  username : values.username,
                  password :values.password
              })
            }
        });
    }

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
          callback('Two passwords that you enter is inconsistent!');
        } else {
          callback();
        }
      };
    
      validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
          form.validateFields(['confirm'], { force: true });
        }
        callback();
      };


    render(){
        const { getFieldDecorator } = this.props.form
        return(
            
            <Form onSubmit={this.handleSubmit}>
                <Row gutter={10}>
                <Col span={12}>
                <Form.Item label="First Name">
                    {getFieldDecorator("firstName",{
                        initialValue : this.state.data.first_name,
                        rules : [{required:true , message : "Please enter first name"}]
                    })(<Input/>
                    )}
                </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Last Name">
                        {getFieldDecorator("lastName",{
                            initialValue : this.state.data.last_name,
                            rules : [{required:true , message : "Please enter last name"}]
                        })(<Input/>
                        )}
                    </Form.Item>
                </Col>
                <Col span={12}>
                <Form.Item label="NIC">
                    {getFieldDecorator("nic",{
                        initialValue : this.state.data.nic,
                        rules : [{required:true , message : "Please enter nic"}]
                    })(<Input/>
                    )}
                </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Username">
                        {getFieldDecorator("username",{
                            initialValue : this.state.data.username,
                            rules : [{required:true , message : "Please enter username"}]
                        })(<Input/>
                        )}
                    </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item>
                     Reset password : <Checkbox onChange={e => this.setState({resetPassword:e.target.checked})} />
                     </Form.Item>
                    <Col span={12}>
                    <Form.Item  label="Enter password"> 
                        {getFieldDecorator("password",{
                            rules : [
                                // {required:true , message : "Please enter password"},
                                {validator : this.validateToNextPassword}
                            ]   
                            })(<Input disabled={!this.state.resetPassword} type="password" />
                        )}
                    </Form.Item>
                    </Col>
                    <Col span={12}>
                        
                        <Form.Item label="Confirm password"> 
                            {getFieldDecorator("confirmPassword",{
                            rules : [
                                // {required:true , message : "Please confirm password"},
                                {validator : this.compareToFirstPassword}
                            ]
                        
                        })(<Input disabled={!this.state.resetPassword}  onBlur={this.handleConfirmBlur}  type="password" />
                        )}
                        </Form.Item>
                    </Col>
                    <Col span={8} offset={16}>
                    <Form.Item>
                        <Button block loading={this.state.loading} type="primary" htmlType="submit">Save</Button>
                    </Form.Item>
                    </Col>
               </Col>
                </Row>
            </Form>
        )
    }

}




const mapStateToProps = (state) => ({
    server : state.entity.server
})

export default connect(mapStateToProps,null)(Form.create({name:"edit-employee-form"})(EditEmployee))